/**
 * Reusable stat card for the dashboard.
 * Displays a title, large value, and optional change indicator.
 */
export default function StatCard({ title, value, change, trend, subtitle }) {
  const trendClass = trend === 'up'
    ? 'v2-stat-card-change--up'
    : 'v2-stat-card-change--down'

  const trendArrow = trend === 'up' ? '\u2191' : '\u2193'

  return (
    <div className="v2-stat-card">
      <span className="v2-stat-card-title">{title}</span>
      <span className="v2-stat-card-value">{value}</span>
      {change && (
        <span className={`v2-stat-card-change ${trendClass}`}>
          {trendArrow} {change}
        </span>
      )}
      {subtitle && (
        <span className="v2-stat-card-sub">{subtitle}</span>
      )}
    </div>
  )
}
